module.exports = __webpack_public_path__ + "media/images/5-elements-6622f2302d241dac7c4c4f87a5ebe293.svg";